import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress, // Import CircularProgress
} from "@mui/material";

import { useTransactionContext } from "../../contexts/TransactionContext/TransactionContext";

import { Transaction } from "../../types/Transaction";
import useAccelContext from "../../contexts/AccelContext";

const LineItems = ({ filterType }: { filterType: string }) => {
  const { transactions, loadingStatus, error } = useTransactionContext();
  const { theme } = useAccelContext();
  const [filteredItems, setFilteredItems] = useState<Transaction[]>([]);

  useEffect(() => {
    if (!transactions) return; // Check if transactions is undefined and return early

    const getFilteredItems = () => {
      let result = [];
      for (let transaction of transactions) {
        if (
          filterType === "uncategorized" &&
          transaction.status?.toString() === "PENDING"
        ) {
          result.push(transaction);
        } else if (
          transaction.direction?.toString() === filterType.toUpperCase()
        ) {
          result.push(transaction);
        }
      }
      return result;
    };

    setFilteredItems(getFilteredItems());
  }, [transactions, filterType]);

  // Style for the scrollable table body
  const scrollableTableStyle = {
    maxHeight: "300px", // Adjust height as needed to fit 10 rows
    overflowY: "scroll",
    fontSize: "0.7rem", // Smaller text size
  };

  return (
    <Card
      sx={{
        backgroundColor: theme?.accent?.hex,
        width: "100%",
        height: "300px",
        overflowY: "scroll",
      }}
    >
      <CardContent sx={{ width: "100%" }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: theme?.text?.hex || "#000000", // Updated text color
            fontSize: "14px",
          }}
        >
          Line Items -{" "}
          {filterType
            ? filterType.charAt(0).toUpperCase() + filterType.slice(1)
            : "N/A"}
        </Typography>
        {!transactions ? ( // Check if transactions is empty
          <CircularProgress sx={{ color: theme?.primary?.hex || "#000000" }} />
        ) : (
          <Table
            size="small"
            sx={{
              width: "100%",
              tableLayout: "fixed",
              "& .MuiTableCell-root": {
                padding: "8px",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ color: theme?.text?.hex || "#000000" }}>
                  Item
                </TableCell>
                <TableCell
                  align="left"
                  style={{ color: theme?.text?.hex || "#000000" }}
                >
                  Quantity
                </TableCell>
                <TableCell
                  align="left"
                  style={{ color: theme?.text?.hex || "#000000" }}
                >
                  Price
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredItems.map(
                (
                  item,
                  index // Only display up to 10 items
                ) => (
                  <TableRow sx={{ width: "100%" }} key={index}>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        fontFamily: "Helvetica Neue",
                        color: theme?.secondary?.hex || "#000000", // Updated text color
                        backgroundColor: theme?.accent?.hex || "#000000", // Updated background color
                      }}
                    >
                      {new Date(item.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        fontSize: "14px",
                        fontFamily: "Helvetica Neue",
                        color: theme?.secondary?.hex || "#000000", // Updated text color
                        backgroundColor: theme?.accent?.hex || "#000000", // Updated background color
                      }}
                    >
                      {item.counterparty_name}
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        fontSize: "14px",
                        fontFamily: "Helvetica Neue",
                        color: theme?.secondary?.hex || "#000000", // Updated text color
                        backgroundColor: theme?.accent?.hex || "#000000", // Updated background color
                      }}
                    >
                      ${item.amount}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default LineItems;
